import { useInitializeDocumentBatch, useInitializeDocumentBatchUsers, useInitializeDocumentTypes } from './hooks'

interface DocumentBatchInitializationProps {
  documentBatchId: string
}

export const DocumentBatchInitialization: React.FC<DocumentBatchInitializationProps> = ({ documentBatchId }) => {
  useInitializeDocumentTypes()
  useInitializeDocumentBatch(documentBatchId)
  useInitializeDocumentBatchUsers()

  return null
}
